import { render } from "./IconButtonComponent.vue?vue&type=template&id=d943a802&scoped=true"
import script from "./IconButtonComponent.vue?vue&type=script&lang=js"
export * from "./IconButtonComponent.vue?vue&type=script&lang=js"

import "./IconButtonComponent.vue?vue&type=style&index=0&id=d943a802&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d943a802"]])

export default __exports__